import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { emptyService, WEEKDAYS } from '../../lib/onboardShop/helpers';

export const StepServices = ({ services, setServices }) => {
  const upd = (i, patch) => setServices(services.map((s, idx) => idx === i ? { ...s, ...patch } : s));
  const rm = (i) => setServices(services.filter((_, idx) => idx !== i));
  const add = () => setServices([...services, emptyService()]);

  return (
    <>
      <h3 className="admin-info-header">Services</h3>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, margin: '0 0 14px' }}>
        <div className="sub" style={{ color: 'var(--mute)' }}>Optional. You can add services later from the shop dashboard.</div>
        <button className="btn s" onClick={add} data-testid="wiz-services-add" style={{ flexShrink: 0 }}><Plus size={14} /> Add service</button>
      </div>

      {services.length === 0 && <div style={{ color: 'var(--mute2)', padding: '16px 0' }}>No services yet.</div>}
      {services.map((s, i) => (
        <div key={i} className="rep-card" data-testid={`wiz-service-${i}`}>
          <div className="rep-card-h">
            <b>Service #{i + 1}</b>
            <button className="btn s" onClick={() => rm(i)} data-testid={`wiz-service-remove-${i}`}><Trash2 size={14} /></button>
          </div>
          <div className="wiz-row three">
            <div className="field"><label>Name</label>
              <input className="inp" value={s.name} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`wiz-service-name-${i}`} />
            </div>
            <div className="field"><label>Duration (min)</label>
              <input className="inp" type="number" min="5" step="5" value={s.duration_min} onChange={(e) => upd(i, { duration_min: e.target.value })} data-testid={`wiz-service-duration-${i}`} />
            </div>
            <div className="field"><label>Price (£)</label>
              <input className="inp" type="number" min="0" step="0.5" value={s.price} onChange={(e) => upd(i, { price: e.target.value })} data-testid={`wiz-service-price-${i}`} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export const StepHours = ({ barbers, setBarbers }) => {
  if (barbers.length === 0) {
    return (
      <>
        <h3 className="admin-info-header">Working hours</h3>
        <div style={{ color: 'var(--mute2)' }}>Add a barber first (previous step) to set hours.</div>
      </>
    );
  }
  const updHour = (bi, wi, patch) => {
    setBarbers(barbers.map((b, idx) => {
      if (idx !== bi) return b;
      return { ...b, hours: b.hours.map((h, hi) => hi === wi ? { ...h, ...patch } : h) };
    }));
  };

  return (
    <>
      <h3 className="admin-info-header">Working hours</h3>
      <div className="sub" style={{ color: 'var(--mute)', margin: '4px 0 14px' }}>Set the days each barber works. You can fine-tune later.</div>
      {barbers.map((b, bi) => (
        <div key={bi} className="rep-card" data-testid={`wiz-hours-barber-${bi}`}>
          <div className="rep-card-h"><b>{b.name || `Barber #${bi + 1}`}</b></div>
          <div className="hours-grid">
            <div className="hd">Day</div><div className="hd">Start</div><div className="hd">End</div><div className="hd">Open</div>
          </div>
          {b.hours.map((h, hi) => (
            <div key={hi} className="hours-grid">
              <div>{WEEKDAYS[h.weekday]}</div>
              <input className="inp" type="time" value={h.start_time} disabled={!h.is_open} onChange={(e) => updHour(bi, hi, { start_time: e.target.value })} data-testid={`wiz-hours-${bi}-${hi}-start`} />
              <input className="inp" type="time" value={h.end_time} disabled={!h.is_open} onChange={(e) => updHour(bi, hi, { end_time: e.target.value })} data-testid={`wiz-hours-${bi}-${hi}-end`} />
              <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <input type="checkbox" checked={h.is_open} onChange={(e) => updHour(bi, hi, { is_open: e.target.checked })} data-testid={`wiz-hours-${bi}-${hi}-open`} />
              </label>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export const StepStripe = () => (
  <>
    <h3 className="admin-info-header">Stripe Connect</h3>
    <div className="sub" style={{ color: 'var(--mute)', margin: '4px 0 14px' }}>
      This step is skippable. The owner can start Stripe KYC from their dashboard&apos;s Payments page
      after they sign in. Bookings work without Stripe (no deposit collected).
    </div>
    <div style={{ padding: '20px 0', color: 'var(--mute2)' }}>Skip this step for now — the owner will complete KYC from the Payments page after signing in.</div>
  </>
);
